window.SiteReady(($) => {

  const $window = $(window);
  const $body = $('body');

  $body.on('mouseleave', (e) => {
    if (e.clientY < 0) {
      $window.trigger('exitintent');
    }
  });

});